import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'
import { handleFormData } from '@/utils/handleFormData'
/**
 * 分流关系设置
 * 提交
 * @param {*} params
 */
export function setShuntingAdd(data) {
  return request({
    url: BASE_API() + '/setShunting/add',
    method: 'post',
    data
  })
}

/*
*查询经销商的分流客户
 */
export function apiFindDealers(params) {
  return request({
    url: BASE_API() + '/setShunting/findDealers',
    method: 'get',
    params
  })
}

/**
 * 要货申请单
 * 查询要货申请明细
 * @param {*} params
 */
export function findWantGoodsDetailByClient(data) {
  return request({
    url: BASE_API() + '/wantgoods/findCustomerInfo',
    // url: BASE_API() + '/wantgoods/findTicketDetail',
    method: 'get',
    params: data
  })
}

/**
 * 要货申请
 * 查询待要货申请明细
 * @param {*} params
 */
export function findWantGoodsDetailByStay(data) {
  return request({
    url: BASE_API() + '/wantgoods/findAppliedAll',
    method: 'post',
    data
  })
}

/**
 * 要货申请
 * 查询待要货申请明细
 * @param {*} params
 */
export function findByInvoInfoid(params) {
  return request({
    url: BASE_API() + '/wantgoods/findByInvoInfoid',
    method: 'get',
    params
  })
}

/**
* 要货申请单
* 查询申请单
* @param {*} params
*/
export function wantgoodsFindById(params) {
  return request({
    url: BASE_API() + '/wantgoods/findById',
    method: 'post',
    params
  })
}

/**
* 要货申请单查询
* 查询申请单查询
* @param {*} params
*/
export function findWantGoodsList(data) {
  return request({
    // url: BASE_API() + '/wantgoods/findGoodsSingle',
    url: BASE_API() + '/wantGoodsDataQuery/findGoodsSingle',
    method: 'post',
    data
  })
}
/**
 * 要货申请单明细查询
 * 查要货申请单明细查询
 * @param {*} params
 */
export function findWantGoodsDetailById(data) {
  return request({
    url: BASE_API() + '/wantgoods/findWantGoodsById',
    method: 'get',
    params: data
  })
}

/**
 * 停发货查询
 * 查询停发货单据
 * @param {*} params
 */
export function findStopShippingList(data) {
  return request({
    url: BASE_API() + '/stopdelivery/findStopDeliveryAll',
    method: 'post',
    data
  })
}
/**
 * 停发货关闭
 * @param {*} params
 */
export function apiStopdeliveryCloseStatus(data) {
  return request({
    url: BASE_API() + '/stopdelivery/closeStatus',
    method: 'post',
    needFormat: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data
  })
}

/**
 * 停发货单
 * 查询停发货单据
 * @param {*} params
 */
export function stopdeliveryFindById(params) {
  return request({
    url: BASE_API() + '/stopdelivery/findById',
    method: 'post',
    params
  })
}

/**
 * 分流关系设置
 * 查询分流关系设置
 * @param {*} params
 */
export function setShuntingFindById(params) {
  return request({
    url: BASE_API() + '/setShunting/findById',
    method: 'post',
    params
  })
}

/**
 * 货权转移申请
 * 查询货权转移申请
 * @param {*} params
 */
export function transfergoodsrightsFindById(params) {
  return request({
    url: BASE_API() + '/transfergoodsrights/findById',
    method: 'post',
    params
  })
}

/**
 * 货权转移历史查询
 * 查询货权转移申请
 * @param {*} params
 */
export function getTransfergoodsrightsHist(data) {
  return request({
    url: BASE_API() + '/transfergoodsrights/findTransHist',
    method: 'post',
    data
  })
}

/**
 * 货权转移申请
 * 查询货权转移申请
 * @param {*} params
 */
export function transfergoodsrightsInitByItemId(params) {
  return request({
    url: BASE_API() + '/transfergoodsrights/initByInvItemId',
    method: 'get',
    params
  })
}

/**
 * 要货控制
 * 要货控制查询
 * @param {*} params
 */
export function findDeliveryControlAll(data) {
  return request({
    url: BASE_API() + '/deliveryControl/findDeliveryControlAll',
    method: 'post',
    data
  })
}

/**
 * 要货控制
 * 要货控制设置
 * @param {*} params
 */
export function deliveryControlAdd(data) {
  return request({
    url: BASE_API() + '/deliveryControl/add',
    method: 'post',
    data
  })
}

/**
 * 要货控制
 * 要货控制删除明细信息
 * @param {*} params
 */
export function deleteDeliverControl(params) {
  return request({
    url: BASE_API() + '/deliveryControl/deleteDeliverControl',
    method: 'delete',
    params
  })
}

/**
 * 要货控制
 * 要货控制详情
 * @param {*} params
 */
export function deliveryControlFindById(params) {
  return request({
    url: BASE_API() + '/deliveryControl/findById',
    method: 'get',
    params
  })
}

/**
 * 经销商库存提报
 * 查询经销商库存提报
 * @param {*} params
 */
export function findStockReport(data) {
  return request({
    url: BASE_API() + '/stockReport/findStockReport',
    method: 'post',
    data
  })
}

/**
 * 经销商库存提报
 * 保存经销商库存提报
 * @param {*} params
 */
export function saveStockReport(data) {
  return request({
    url: BASE_API() + '/stockReport/saveStockReport?type=' + data.type,
    method: 'post',
    data
  })
}

/**
 * 经销商库存提报
 * 删除经销商库存提报明细
 * @param {*} params
 */
export function deleteStockReportSub(params) {
  return request({
    url: BASE_API() + '/stockReport/deleteStockReportSub',
    method: 'get',
    params
  })
}

/**
 * 经销商库存提报
 * 根据billCode查询经销商库存提报
 * @param {*} params
 */
export function findStockReportByCode(params) {
  return request({
    url: BASE_API() + '/stockReport/findStockReportByCode',
    method: 'get',
    params
  })
}

/**
 * 经销商发票冻结
 * 查询经销商发票冻结查询
 * @param {*} data
 */
export function findInvoiceFreeze(data) {
  return request({
    // url: BASE_API() + '/invoiceFreeze/findInvoiceFreeze',
    url: BASE_API() + '/wantGoodsDataQuery/findInvoiceFreeze',
    method: 'post',
    data
  })
}
/**
 * 经销商发票冻结
 * 查询经销商发票剩余量
 * @param {*} params
 */
export function findInvoiceRemainQty(data) {
  return request({
    url: BASE_API() + '/invoiceFreeze/findInvoiceRemainQty',
    method: 'post',
    data
  })
}

/**
 * 经销商发票冻结
 * 保存经销商发票数量冻结
 * @param {*} data
 */
export function saveInvoiceFreeze(data) {
  return request({
    url: BASE_API() + '/invoiceFreeze/saveInvoiceFreeze',
    method: 'post',
    data
  })
}

/**
 * 经销商发票冻结
 * 根据id查询发票冻结
 * @param {*} params
 */
export function findInvoiceFreezeById(params) {
  return request({
    url: BASE_API() + '/invoiceFreeze/findInvoiceFreezeById',
    method: 'get',
    params
  })
}

export function dataToCenter(params) {
  return request({
    url: BASE_API() + '/dataToCenter/sendToCenter',
    method: 'get',
    params
  })
}

/**
 * 经销商发票冻结
 * 根据id删除发票冻结
 * @param {*} params
 */
export function deleteInvoiceFreezeSub(params) {
  return request({
    url: BASE_API() + '/invoiceFreeze/deleteInvoiceFreezeSub',
    method: 'get',
    params
  })
}

/**
 * 发货申请（要货入口）
 * 分页查询客户获取获取转移的产品
 * @param {*} data
 */
export function apiGetTrfansferGoods(data) {
  return request({
    url: BASE_API() + '/ticket/getTrfansferGoods',
    method: 'post',
    params: data
  })
}

/**
 * 要货管理 经销商分流
 * 查询客户分流的经销商
 * @param {*} data
 */
export function apiGetListDistributeCust(data) {
  return request({
    url: BASE_API() + '/distributeCustomer/listDistributeCust',
    method: 'get',
    params: data
  })
}

/**
 * 要货管理 KA卖场
 * 查询客KA卖场
 * @param {*} data
 */
export function apiGetListKAStore({ page, data }) {
  return request({
    url: BASE_API() + `/kastore/listKAStore`,
    method: 'post',
    params: page,
    data
  })
}

/**
 * 要货管理 经销商
 * 要货产品信息
 * @param {*} data
 */
export function apiGetProdDeliveryPlan(data) {
  return request({
    url: BASE_API() + '/wantgoods/getProdDeliveryPlan',
    method: 'post',
    data
  })
}

/**
 * 要货管理 查询中台的库存量和在途量
 * 要货产品信息
 * @param {*} data
 */
export function apiGetProdMiddleStockData(data) {
  return request({
    url: BASE_API() + '/wantgoods/getProdMiddleStockData',
    method: 'post',
    data
  })
}
/**
 * 要货管理
 * 保存业务数据
 * @param {*} data
 */
export function apiSaveBizData(data) {
  return request({
    url: BASE_API() + '/wantgoods/saveBizData',
    method: 'post',
    data
  })
}

/**
 * 发货申请（要货入口）
 * 分页查询客户可要货产品
 * @param {*} data
 */
export function apiGetUnFinishedInv(data) {
  return request({
    url: BASE_API() + '/Invinfo/getUnFinishedInv',
    method: 'post',
    params: data
  })
}

/**
 * 货权转移申请（要货入口）
 * 分页查询客户获取获取转移的产品
 * @param {*} data
 */
export function apiGetTransferUnFinishedInv(data) {
  return request({
    url: BASE_API() + '/Invinfo/getTransferUnFinishedInv',
    method: 'post',
    params: data
  })
}

/**
 * 货权转移申请（要货入口）
 * 分页查询客户获取获取转移的产品
 * @param {*} data
 */
export function apiGetTransferGoodsInvInfo(data) {
  return request({
    url: BASE_API() + '/Invinfo/getTransferGoods',
    method: 'post',
    params: data
  })
}
/**
 * 货权转移申请（分页查询）
 * 分页查询货权转移申请单
 * @param {*} data
 */
export function apiGetTransferGoodsByPage(data) {
  return request({
    // url: BASE_API() + '/transfergoodsrights/findTransferGoodsRightsDTOByPage',
    url: BASE_API() + '/wantGoodsDataQuery/findTransferGoodsRightsDTOByPage',
    method: 'post',
    data
  })
}

/**
 * 货权转移申请（查询）
 * 查询货权转移申请单
 * @param {*} data
 */
export function apiGetTransferGoods(data) {
  return request({
    url: BASE_API() + '/transfergoodsrights/findTransferGoodsRightsDTO',
    method: 'post',
    data
  })
}

/**
 * 货权转移客户设置 - 新增
 * @param {*} data
 */
export function addTransferCustomerSetting(data) {
  return request({
    url: BASE_API() + '/transfergoodsrights/addTransferCustomerSetting',
    method: 'post',
    data
  })
}

/**
 * 货权转移客户设置 - 删除
 * @param {*} params
 */
export function deleteTransferCustomerSetting(params) {
  return request({
    url: BASE_API() + '/transfergoodsrights/deleteTransferCustomerSetting',
    method: 'post',
    params: params
  })
}

/**
 * 货权转移客户设置 - 查询转出客户对应的转入客户列表
 * @param {*} data
 */
export function findReceiveCustomersByTransferCustomer(data) {
  return request({
    url: BASE_API() + '/transfergoodsrights/findReceiveCustomersByTransferCustomer',
    method: 'post',
    data
  })
}

/**
 * 货权转移客户设置 - 分页查询
 * @param {*} data
 */
export function findTransferCustomerSettingByPage(data) {
  return request({
    url: BASE_API() + '/transfergoodsrights/findTransferCustomerSettingByPage',
    method: 'post',
    data
  })
}

/**
 * 货权转移任意客户设置 - 新增
 * @param {*} data
 */
export function addTransferAnyCustomerSetting(data) {
  return request({
    url: BASE_API() + '/transfergoodsrights/addTransferAnyCustomerSetting',
    method: 'post',
    data
  })
}

/**
 * 货权转移任意客户设置 - 删除
 * @param {*} params
 */
export function deleteTransferAnyCustomerSetting(params) {
  return request({
    url: BASE_API() + '/transfergoodsrights/deleteTransferAnyCustomerSetting',
    method: 'post',
    params: params
  })
}

/**
 * 货权转移任意客户设置 - 分页查询
 * @param {*} data
 */
export function findTransferAnyCustomerSettingByPage(data) {
  return request({
    url: BASE_API() + '/transfergoodsrights/findTransferAnyCustomerSettingByPage',
    method: 'post',
    data
  })
}

/**
 * 重传要货数据给安吉
 * @param data
 */

export function apiAgainSendData(data) {
  return request({
    url: BASE_API() + '/wantgoods/againSendData',
    method: 'post',
    data
  })
}

// 取消要货审批查询详情
export function apiCancelToGoodsDetail(params) {
  return request({
    url: BASE_API() + '/wantgoods/findCancelOrderById',
    method: 'get',
    params
  })
}

export function validateQtyInfo(params) {
  return request({
    url: BASE_API() + '/dataToCenter/validateQtyInfo',
    method: 'post',
    params
  })
}

/**
 * 发票信息查询
 * 查询申请单查询
 * @param {*} params
 */
export function findInvoiceSearchList(data) {
  return request({
    url: BASE_API() + '/wantGoodsDataQuery/findInvoiceSearchList',
    method: 'post',
    data
  })
}

/**
* 发货运费结算查询
* 查询申请单查询
* @param {*} params
*/
export function apiFindFreightSettleQuery(data) {
  return request({
    url: BASE_API() + '/deliverCheck/findFreightSettleQuery',
    method: 'post',
    data
  })
}

/**
 * 要货单物流信息查询
 * @param {*} params
 */
export function apiWantGoodsLogistics(data) {
  return request({
    url: BASE_API() + '/logistics/queryLogistics',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      needFormat: true
    },
    data
  })
}

/**
 * 发货核对查询
 * 查询申请单查询
 * @param {*} params
 */
export function findDeliveryCheckSearchList(data) {
  return request({
    url: BASE_API() + '/deliverCheck/findDeliverCheck',
    method: 'post',
    data
  })
}

/**
 * 发货核对查询未处理的单据
 * 查询申请单查询
 * @param {*} params
 */
export function findDeliveryCheckNoProcessList(data) {
  return request({
    url: BASE_API() + '/deliverCheck/findDeliverCheckList',
    method: 'post',
    data
  })
}

/**
 * 发货运费结算查询未处理的单据
 * 查询申请单查询
 * @param {*} params
 */
export function findDeliverySettleNoProcessList(data) {
  return request({
    url: BASE_API() + '/deliverCheck/findDeliverSettleList',
    method: 'post',
    data
  })
}

/**
 * 发货核对 更新处理状态
 * 查询申请单查询
 * @param {*} params
 */
export function setHandlerStatus(data) {
  return request({
    url: BASE_API() + '/deliverCheck/updateHandleStatus',
    method: 'post',
    data
  })
}

/**
 * 发货运费结算 更新处理状态
 * 查询申请单查询
 * @param {*} params
 */
export function setSettleStatus(data) {
  return request({
    url: BASE_API() + '/deliverCheck/updateSettleBillStatus',
    method: 'post',
    data
  })
}

/**
 * 根据发货计划获取其渠道类型
 * 查询申请单查询
 * @param {*} params
 */
export function getChannel(data) {
  return request({
    url: BASE_API() + '/wantgoods/getChannelType',
    method: 'post',
    data
  })
}

/**
 * 发运信息查询
 */
export function getShippingInformationReport(data) {
  return request({
    url: BASE_API() + '/wantgoodsreport/ShippingInformationReport',
    method: 'post',
    data
  })
}
/**
 * 发运信息后端导出
 * @param {*} params
 */
export function apiExportExcelShippingInfoDatas(data) {
  return request({
    url: BASE_API() + `/wantgoodsreport/ShippingInfoExportDatas?templateCode=${data.templateCode}`,
    method: 'post',
    data
  })
}

/**
 * 发货单后端导出
 * @param {*} params
 */
export function apiExportExcelWantGoodsDatas(data) {
  return request({
    url: BASE_API() + `/wantGoodsDataQuery/wantGoodsExportDatas?templateCode=${data.templateCode}`,
    method: 'post',
    data
  })
}
/**
 * 经销商开票量使用明细后端导出
 * @param {*} params
 */
export function apiExportExceldealerMakeInvoiceInfoDatas(data) {
  return request({
    url: BASE_API() + `/wantgoodsreport/makeInvoiceInfoExportDatas?templateCode=${data.templateCode}`,
    method: 'post',
    data
  })
}

/**
* 发运信息明细查询
*/
export function getShippingDetailReport(data) {
  return request({
    url: BASE_API() + '/wantgoodsreport/ShippingDetailsReport',
    method: 'post',
    data
  })
}

/**
 * 发运计划执行情况统计
 */
export function getShippingPlanImplementReport(data) {
  return request({
    url: BASE_API() + '/wantgoodsreport/findShippingPlanImplementReport',
    method: 'post',
    data
  })
}

/**
 * 营销中心产品开票量使用汇总表
 */
export function getSalesCenterProductReport(data) {
  return request({
    url: BASE_API() + '/wantgoodsreport/findSalesCenterProductReport',
    method: 'post',
    data
  })
}

/**
 * 经销商开票量使用明细
 */
export function getDealerInvUseDtlReport(data) {
  return request({
    url: BASE_API() + '/wantgoodsreport/findDealerInvoicingReport',
    method: 'post',
    data
  })
}
/**
 * 老要货系统未发完货发票
 */
export function apiGetYQInvoice(data) {
  return request({
    url: BASE_API() + '/Invinfo/getOldSysInv',
    method: 'post',
    params: data
  })
}
/**
 * 查询客户的分流关系
 */
export function apiSetShuntingFindByCustomer(params) {
  return request({
    url: BASE_API() + '/setShunting/findByCustomer',
    method: 'get',
    params
  })
}

/**
* 查询客户的分流关系（带过滤条件）
*/
export function apiSetShuntingFindByCustomerWithFilter(data) {
  return request({
    url: BASE_API() + '/setShunting/findByCustomerWithFilter',
    method: 'post',
    data
  })
}
/**
 * 查询要货单据安吉发运信息
 */
export function apiFindAnJiOrderStatus(params) {
  return request({
    url: BASE_API() + '/wantgoods/findAnJiOrderStatus',
    method: 'get',
    params
  })
}
/**
 * 发货控制查询
 */
export function apiDeliveryControlList(data) {
  return request({
    url: BASE_API() + '/wantGoodsDataQuery/findDeliveryCtrl',
    method: 'post',
    data
  })
}
/**
 * 要货申请表打印
 */
export function apiDeliveryPrint(params) {
  return request({
    url: BASE_API() + '/wantgoods/printWantGoodsInfo',
    method: 'post',
    params,
    responseType: 'blob'
  })
}
/**
 * 要货申请表打印
 */
export function apiFindCancelOrder(data) {
  return request({
    url: BASE_API() + '/wantgoods/findCancelOrder',
    method: 'post',
    data
  })
}
/**
 * 设置要货单自动删除时间
 */
export function apiAddOutTime(data) {
  return request({
    url: BASE_API() + '/setOutTime/addOutTime',
    method: 'post',
    data
  })
}
/**
 * 货单自动删除时间查询
 */
export function apiFindALSetTime() {
  return request({
    url: BASE_API() + '/setOutTime/findALSetTime',
    method: 'get'
  })
}
/**
 * 存新酒存储单查询
 */
export function findStorageSingle(data) {
  return request({
    url: BASE_API() + '/wantgoods/findStorageSingle',
    method: 'post',
    data
  })
}
/**
 * 修改存新酒存储单期限
 */
export function adjustStorageTime(data) {
  return request({
    url: BASE_API() + '/wantgoods/adjustStorageTime',
    method: 'post',
    data
  })
}

/**
 * 流程轨迹（带电话号码的）
 */
export function queryApprovalHistoryByBizIdPhone(data) {
  return request({
    url: BASE_API() + '/wantgoods/findApprovalHistoryByBizId',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: handleFormData(data)
  })
}
// 查询客户是否有分流任意客户的权限
export function findShuntAnyByDealer(data) {
  return request({
    url: BASE_API() + '/setShunting/findShuntAnyByDealer',
    method: 'get',
    params: data
  })
}
// 存新酒二次要货的列表查询数据库接口
export function getUnFinishedInvByStore(data) {
  return request({
    url: BASE_API() + '/Invinfo/getUnFinishedInvByStore',
    method: 'post',
    params: data
  })
}
// 以酒促酒要货的列表查询数据库接口
export function getUnFinishedInvByPromote(data) {
  return request({
    url: BASE_API() + '/Invinfo/getUnFinishedInvByPromote',
    method: 'post',
    params: data
  })
}
// 查询终端
export function queryDirectStore(data) {
  return request({
    url: BASE_API() + '/storeDealer/queryDirectStore',
    method: 'post',
    data
  })
}
// 查询终端要货 历史地址
export function findFirstByTerminalId(data) {
  return request({
    url: BASE_API() + '/wantgoods/findFirstByTerminalId',
    method: 'post',
    params: data
  })
}

/**
* 终端直配查询申请单查询
* @param {*} params
*/
export function findGoodsSingleJoinBoxBarcode(data) {
  return request({
    url: BASE_API() + '/wantGoodsDataQuery/findGoodsSingleJoinBoxBarcode',
    method: 'post',
    data
  })
}
/**
 * 终端直配发货单后端导出
 * @param {*} params
 */
export function exportExcelGoodsSingleJoinBoxBarcode(data) {
  return request({
    url: BASE_API() + `/wantGoodsDataQuery/exportExcelGoodsSingleJoinBoxBarcode?templateCode=${data.templateCode}`,
    method: 'post',
    data
  })
}
// 嵌入第三方页面校验 需要的token
export function getClientByApp(data) {
  return request({
    url: BASE_API() + `/platform/getClientByApp`,
    method: 'get',
    params: data
  })
}
/**
* 终端直配查询子账号
* @param {*} params
*/
export function findCustomerByChild(data) {
  return request({
    url: BASE_API() + '/wantgoods/findCustomerByChild?childCode='+ data.user_bp,
    method: 'post',
  })
}

/**
* 子账号要货申请单查询
* 查询申请单查询
* @param {*} params
*/
export function findChildGoodsSingle(data) {
  return request({
    // url: BASE_API() + '/wantgoods/findGoodsSingle',
    url: BASE_API() + '/wantGoodsDataQuery/findChildGoodsSingle',
    method: 'post',
    data
  })
}
/**
*  判断要货否超月计划数量
* @param {*} params
*/
export function exceedMonthPlan(data) {
  return request({
    url: BASE_API() + '/wantgoods/exceedMonthPlan',
    method: 'post',
    data
  })
}
/**
*  最近三次要货数据
* @param {*} params
*/
export function findLastThreeTimesWantDetail(data) {
  return request({
    url: BASE_API() + '/wantgoods/findLastThreeTimesWantDetail',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: handleFormData(data)
  })
}
/**
* 终端直配要货单查询
* @param {*} params
*/
export function statInfo(data) {
  return request({
    url: BASE_API() + '/wantGoodsDataQuery/statInfo',
    method: 'post',
    data
  })
}
/**
* 可放行数量
* @param {*} params
*/
export function queryPledgeQuantity(data) {
  return request({
    url: BASE_API() + '/wantGoodsDataQuery/anji/queryPledgeQuantity',
    method: 'post',
    data
  })
}
/**
* 实时库存量
* @param {*} params
*/
export function thirdRealTimeInventory(data) {
  return request({
    url: BASE_API() + '/wantGoodsDataQuery/thirdRealTimeInventory',
    method: 'post',
    data
  })
}
/**
* 终端直配发货单后端导出
* @param {*} params
*/
export function apiExportExcelWantGoodsTerminalDatas(data) {
  return request({
    url: BASE_API() + `/wantGoodsDataQuery/wantGoodsTerminalExportExcel?templateCode=${data.templateCode}`,
    method: 'post',
    data
  })
}

/**
* 经销商分流客户查询
* @param {*} params
*/
export function findDealerShuntClientsPage(data) {
  return request({
    url: BASE_API() + '/setShunting/findDealerShuntClientsPage',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/applyForGoods/index.js